
__webpack_require__.remotesLoadingData = { chunkMapping: {"4320":["13976"]}, moduleIdToRemoteDataMapping: {"13976":{"shareScope":"default","name":"./AzaGlobalFab","externalModuleId":29680,"remoteName":"atozassistant"}} };
__webpack_require__.f.remotes = __webpack_require__.f.remotes || function() { throw new Error("should have __webpack_require__.f.remotes"); }
